import * as types from '../types';
import { IAuditLogsApi } from '../contracts';
import { HttpApi } from './HttpApi';

const BASE = '/audit-logs';

export class AuditLogsHttpApi extends HttpApi implements IAuditLogsApi {
  async listAuditLogs(
    page = 1,
    limit = 50,
    filters: types.AuditLogListFilters = {}
  ): Promise<types.PaginatedResponse<types.AuditLogEntry>> {
    // Blank filters are left out: the server rejects e.g. action='' (400 INVALID_FILTER).
    const params: Record<string, string | number> = { page, limit };
    (['actorUserId', 'action', 'targetUserId', 'startDate', 'endDate'] as const).forEach((key) => {
      const value = filters[key];
      if (value) params[key] = value;
    });
    const response = await this.http.get<types.PaginatedResponse<types.AuditLogEntry>>(BASE, { params });
    return response.data;
  }

  async listAuditLogActions(): Promise<string[]> {
    const response = await this.http.get<types.APIResponse<string[]>>(`${BASE}/actions`);
    return response.data.data;
  }
}
